import { useMutation } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { IRQCallbacks } from '../../../types/my-types';
import { Packager } from '../../../types/packager-types';

type IusePackagerUpdateProps = {
  dataPoolId: string;
  packagerId: string;
  data: Packager;
};

export const usePackagerUpdate = (callbacks?: IRQCallbacks) => {
  const glynt = useGlynt();

  return useMutation({
    mutationFn: async (data: IusePackagerUpdateProps) => {
      return await (await glynt).packager.update(data.dataPoolId, data.packagerId, data.data);
    },

    ...callbacks
  });
};
